/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type HealthLevel = 'UNKNOWN' | 'OK' | 'WARNING' | 'CRITICAL' | 'NOT_APPLICABLE';

export const HealthLevel = {

    UNKNOWN: 'UNKNOWN' as HealthLevel,

    OK: 'OK' as HealthLevel,

    WARNING: 'WARNING' as HealthLevel,

    CRITICAL: 'CRITICAL' as HealthLevel,

    NOT_APPLICABLE: 'NOT_APPLICABLE' as HealthLevel
};

